import { Button, IconHelp, Modal } from "@veneer/core";
import { useEffect, useState } from "react";
import "./help-modal-popup.css";
import { PopupFooter } from "./popup-footer";

export const HelpModalPopup = ({ ...props }) => {
  const [open, setOpen] = useState(false);
  function openPopUP(event: any): void {
    setOpen(true);
    props.callback();
  }
  
  return (
    <span style={{ position: "relative", paddingLeft: "5px" }}>
      {props.IconHide === true ? (
        <span style={{
          color: "#007bff",
          cursor: "pointer",
          textDecoration: "underline"
        }} onClick={openPopUP}>{props.IconText}</span>
      ) : (
        <IconHelp
          className="help-icon"
          filled
          color="#0096d6"
          size={25}
          onClick={openPopUP}
        />
      )}
      <Modal
        className="modal-container"
        align={props.align}
        id={props.id}
        show={open}
        onClose={() => setOpen(false)}
        closeButton={true}
        title={props.title}
        // footer={
        //   <PopupFooter/>
        // }
      >
        <p>{props.children}</p>
      </Modal>
    </span>
  );
};
